import React from "react";
import { Button, CircularProgress } from "@mui/material";

const FormButton = ({ loading, children, ...props }) => (
  <Button {...props} disabled={loading}>
    {loading ? <CircularProgress size={24} color="inherit" /> : children}
  </Button>
);

export default FormButton;
